import { Outlet } from 'react-router-dom'
import Navbar from '@/components/layout/Navbar'
import Footer from '@/components/layout/Footer'
import FloatingChatButton from '@/components/shared/FloatingChatButton'
import ErrorBoundary from '@/components/layout/ErrorBoundary'
export default function PublicLayout() {
  return (
    <>
      <Navbar />
      {/* Zone-level ErrorBoundary (FE-029) — a landing/blog page crash
          stays contained; navbar + footer stay functional. */}
      <main id="main-content">
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </main>
      <Footer />
      <FloatingChatButton />
    </>
  )
}
